import { Injectable, inject } from '@angular/core';
import { AbstractAuthService } from '@zero/shared/util-abstract-services';
import { CustomerStateFacade } from '@zero/shared/util-global-state';
import { ACCOUNT_OPEN_REFERENCE_ID_PARAM_NAME } from 'constants/shared-constants';
import { environment } from 'environments/environment';
import { combineLatest, filter, map, of, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class KwkFacade {
  readonly #authService = inject(AbstractAuthService);
  readonly #customerStateFacade = inject(CustomerStateFacade);

  public readonly isCustomer$ = this.#authService.isCustomer$();

  public readonly isLoggedIn$ = this.#authService.isCustomer$().pipe(
    switchMap((loggedInAndCustomer) => {
      if (loggedInAndCustomer) {
        return of(true);
      } else {
        return this.#authService.isLoggedIn$();
      }
    }),
  );

  public readonly notYetCustomer$ = combineLatest([this.isCustomer$, this.isLoggedIn$]).pipe(
    map(([isCustomer, loggedIn]) => loggedIn && !isCustomer),
  );

  public readonly promoLink$ = this.notYetCustomer$.pipe(
    map((notYetCustomer) => !notYetCustomer),
    switchMap(() => this.#customerStateFacade.loadCustomerBaseData()),
    switchMap(() => this.#customerStateFacade.customerBaseData$),
    map((cbd) => cbd?.personalPromoCode ?? undefined),
    filter((code) => !!code),
    map((code) => `${environment.sitedomain}/depot-eroeffnen?${ACCOUNT_OPEN_REFERENCE_ID_PARAM_NAME}=${code}`),
  );
}
